export enum PaymentProviderEnum {
    VRIO = 1,
    // Legacy. No active Dwolla integration remains; value is persisted (explicit numeric) and kept for historical rows.
    Dwolla = 2,
    GoCardless = 3,
    Konnektive = 4,
}